import { DONATIONS_APP_DEF_ID } from '@/common/constants/app';
import { FlowEditorSDK } from '@wix/yoshi-flow-editor';

export const getAppPageDefinitionData = async (
  editorSDK: FlowEditorSDK,
  tpaPageId: string,
) => {
  const tpaApplicationId = (
    await editorSDK.tpa.app.getDataByAppDefId('', DONATIONS_APP_DEF_ID)
  ).applicationId;
  return {
    tpaApplicationId,
    appDefinitionId: DONATIONS_APP_DEF_ID,
    tpaPageId,
  };
};
